/**
 * StagePips — visual indicator showing cadence chord progress.
 *
 * Used to make the cadence playback feel grounded. As each chord plays, its
 * pip lights up. After all four, all pips fade and the target note plays.
 */

import { type ReactNode } from "react";

export interface StagePipsProps {
  /** Total number of pips. */
  count: number;
  /** Index (0-based) of the currently active pip, or null for none. */
  active: number | null;
  /** Indices already completed. */
  done: number[];
}

export function StagePips({ count, active, done }: StagePipsProps): ReactNode {
  return (
    <div className="flex gap-2.5">
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          className={`flex-1 h-[3px] transition-colors duration-200 ${getPipClass(i, active, done)}`}
          aria-hidden
        />
      ))}
    </div>
  );
}

function getPipClass(i: number, active: number | null, done: number[]): string {
  if (active === i) return "bg-accent";
  if (done.includes(i)) return "bg-inkFaded";
  return "bg-paperDeep";
}
